import {
  AddCollaboratorsHistoryTechSkillRequestList,
  GetCollaboratorsHistoryTechSkillAvailableResponse,
  GetCollaboratorsHistoryTechSkillsResponse,
  UpdateCollaboratorsHistoryTechSkillRequest,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryTechSkillsService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryTechSkillsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryTechSkillsResponse>(
        `v1/collaborators/${collaboratorId}/history/tech-skills?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async getTechSkillsNotAssignedToCollaborator(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryTechSkillAvailableResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryTechSkillAvailableResponse>(
        `v1/collaborators/${collaboratorId}/history/tech-skills-available?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async add(
    collaboratorId: number,
    body: AddCollaboratorsHistoryTechSkillRequestList,
  ): Promise<void> {
    await httpClient.post(
      `v1/collaborators/${collaboratorId}/history/tech-skills`,
      body,
    );
  },
  async update(
    collaboratorId: number,
    collaboratorHistoryTechSkillId: number,
    body: UpdateCollaboratorsHistoryTechSkillRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/tech-skills/${collaboratorHistoryTechSkillId}`,
      body,
    );
  },
  async delete(
    collaboratorId: number,
    collaboratorHistoryTechSkillId: number,
  ): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/tech-skills/${collaboratorHistoryTechSkillId}`,
    );
  },
};

export default CollaboratorsHistoryTechSkillsService;
